import { Outlet } from 'react-router';

const EssenceLayout = () => {
  return <Outlet />;
};

export default EssenceLayout;
